import Meta from "@/vuex/models/meta";
import QRCodeFull from "@/vuex/models/qrCode/qrCode-full";

export default class QRCodeState {
  public listQRCodes: Array<QRCodeFull> | [] = [];
  public qrCodesForCsv: Array<QRCodeFull> | [] = [];
  public meta!: Meta;
}
